/**
 * Member Service - 成员服务
 * 提供 Deal 成员管理相关 API 调用
 */
import api from './api'
import { DealRole, roleDisplayNames } from './invitation'

// ============================================
// 类型定义
// ============================================

export interface DealMember {
  id: string
  dealId: string
  userId: string
  username: string
  email: string
  role: DealRole
  expiresAt?: string
  isExpired: boolean
  daysUntilExpiry?: number
  createdAt: string
}

export interface RenewMemberRequest {
  days: number
}

export interface RenewMemberResponse {
  message: string
  memberId: string
  newExpiresAt: string
}

// ============================================
// API 调用
// ============================================

/**
 * 获取 Deal 的成员列表
 */
export async function getDealMembers(dealId: string): Promise<DealMember[]> {
  const response = await api.get<DealMember[]>(`/members/deal/${dealId}`)
  return response.data
}

/**
 * 续期成员
 */
export async function renewMember(
  memberId: string, 
  days: number = 7
): Promise<RenewMemberResponse> {
  const response = await api.post<RenewMemberResponse>(
    `/members/${memberId}/renew`,
    { days }
  )
  return response.data
}

/**
 * 移除成员
 */
export async function removeMember(memberId: string): Promise<void> {
  await api.delete(`/members/${memberId}`)
}

/**
 * 获取我的成员关系列表
 */
export async function getMyMemberships(): Promise<DealMember[]> {
  const response = await api.get<DealMember[]>('/members/my')
  return response.data
}

/**
 * 获取角色显示名称
 */
export function getRoleDisplayName(role: DealRole): string {
  return roleDisplayNames[role] || role
}

/**
 * 判断是否可以编辑
 */
export function canEdit(role: DealRole): boolean {
  return role === 'owner' || role === 'presales'
}

/**
 * 判断是否需要脱敏视图
 */
export function requiresMaskedView(role: DealRole): boolean {
  return role === 'manager'
}

/**
 * 判断是否可以邀请成员
 */
export function canInvite(role: DealRole): boolean {
  return role === 'owner'
}

export default {
  getDealMembers,
  renewMember,
  removeMember,
  getMyMemberships,
  getRoleDisplayName,
  canEdit,
  requiresMaskedView,
  canInvite
}

